
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import LatelySection from './components/LatelySection';
import ConceptSection from './components/ConceptSection';
import FavoritesSection from './components/FavoritesSection';
import PhilosophySection from './components/PhilosophySection';
import TestimonialsSection from './components/TestimonialsSection';
import FaqSection from './components/FaqSection';
import NewsletterSection from './components/NewsletterSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <CategoriesSection />
      <LatelySection />
      <ConceptSection />
      <FavoritesSection />
      <PhilosophySection />
      <TestimonialsSection />
      <FaqSection />
      <NewsletterSection />
      <Footer />
    </div>
  );
}
